<template>
  <eagle-form
    :form-key="formKey"
  ></eagle-form>
</template>

<script>
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './siteAdminLogFormConfig'
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'site-admin-log-form',
    meta: {},
  }),
  methods: {
    async beforeFormInit() {
      await Promise.all([])
    },
    validateBeforeSave() {
      // TODO
    },
    async readApi(target) {
      return await this.$api.collection.siteAdminLogApi.read(target)
    },
    async createApi(formData) {
      return await this.$api.collection.siteAdminLogApi.create(formData)
    },
    async updateApi(target, formData) {
      return await this.$api.collection.siteAdminLogApi.update(target, formData)
    },
    async deleteApi(target) {
      return await this.$api.collection.siteAdminLogApi.delete(target)
    },
    getFormConfig() {
      return formConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
